import axios from 'axios';
import { refreshToken } from './utils/refreshToken';

// Create the Axios instance
const api = axios.create();

let logoutHandler = null; // Store the logout handler

// Function to set the logout handler from App.js
export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};



// Request Interceptor: Attach the access token to each request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response Interceptor: Handle 401 errors and refresh failures
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401) {
      console.warn("401 Unauthorized - Checking Refresh Token");
      // If this is the refresh request itself failing, logout immediately
      if (originalRequest.url.includes('/refresh')) {
        console.error("🔴 Refresh token expired. Logging out user...");

        // **Force Logout**
	console.log("Clearing tokens...");
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('is_admin');

        // **Redirect to login**
	console.log("Redirecting to login page...");
        window.location.href = '/login';  // 🔹 Send user back to login page
        return Promise.reject(error);
      }

      // If it's a normal request failing due to access token expiry, try refreshing
      if (!originalRequest._retry) {
        originalRequest._retry = true;

        try {
          const newAccessToken = await refreshToken();
          if (newAccessToken) {
	    console.log("✅ New access token acquired:", newAccessToken);
            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            return api(originalRequest);
          } else {
            console.error("❌ Refresh returned null, forcing logout");
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('is_admin');
            window.location.replace('/login');
          }
        } catch (refreshError) {
	  console.error("❌ Failed to refresh token, forcing logout:", refreshError);

          // **Force Logout**
	  console.log("Clearing tokens...");
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('is_admin');

          // **Redirect to login**
          //window.location.href = '/';
	  console.log("Redirecting to login page...");
          window.location.replace('/login');
        }
      }
    }

    return Promise.reject(error);
  }
);

export default api;
